// extracted by mini-css-extract-plugin
export default {"offerTermsContainer":"OfferTerms_offerTermsContainer__SqtJu"};